import { render } from "./EditUserForm.vue?vue&type=template&id=619d6036&ts=true"
import script from "./EditUserForm.vue?vue&type=script&lang=ts"
export * from "./EditUserForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__